var CoreUI = {

    wideScreenWidth: 1350, // see also top.xhtml for navbar
    maxWideScreenWidth: 1850,
    contextRoot : '/not-set',

    fadeOutPage : function() {
        $('#content').fadeTo(1500, 0.5);
        setTimeout(function() {
            $('#content').html(CoreUI.loadDiv()).fadeIn()
        }, 2500);
    },

    ajaxEvent : function(event) {
        if ($('#ajaxIndicator').length == 0)
            return;
        if (event.status == "begin") {
            $('#ajaxIndicator').html(CoreUI.loadIndicator()).fadeIn(100);
            focusedWidget = $('*:focus');
            if (document.activeElement && document.activeElement.tagName != 'BODY')
                focusedWidgetId = $(document.activeElement).attr('id');
        } else if (event.status == "complete") {
            if (document.activeElement && document.activeElement.tagName != 'BODY')
                focusedWidgetId = $(document.activeElement).attr('id');
        } else if (event.status == "success") {
            $('#ajaxIndicator').fadeOut(100);
            if (typeof focusedWidgetId != 'undefined')
                $('#' + focusedWidgetId).focus();
        } else {
            $('#ajaxIndicator').html("!!!");
        }
    },

    ajaxChangeEvent : function(event) {
        if (event.status == "success")
            window.unsavedChanges = true;
        CoreUI.ajaxEvent(event);
    },

    ajaxSaveEvent : function(event) {
        if (event.status == "success")
            window.unsavedChanges = false;
        CoreUI.ajaxEvent(event);
    },

    ajaxEventReplace : function (event) {
        if (event.status == "begin") {
            $(event.source).attr("disabled","true");
            $(event.source).fadeOut(100, function() {
                $(this).replaceWith(CoreUI.loadIndicator());
            });
            if (document.activeElement.tagName != 'BODY')
                focusedWidgetId = $(document.activeElement).attr('id');
        } else if (event.status == "complete") {
            if (document.activeElement.tagName != 'BODY')
                focusedWidgetId = $(document.activeElement).attr('id');
        } else if (event.status == "success") {
            $(event.source).fadeIn();
            if (typeof focusedWidgetId != 'undefined')
                $('#' + focusedWidgetId).focus();
        } else {
            $(event.source).replaceWith('!!!');
        }
    },

    ajaxChangeEventReplace : function(event) {
        if (event.status == "success")
            window.unsavedChanges = true;
        CoreUI.ajaxEventReplace(event);
    },

    ajaxSaveEventReplace : function(event) {
        if (event.status == "success")
            window.unsavedChanges = false;
        CoreUI.ajaxEventReplace(event);
    },

    ajaxError : function(error) {
        if ($('#errorDiv').length == 0) {
            $('<div id="errorDiv"></div>').dialog({
                    title: i18next.t('errorTitle'),
                    width: 400,
                    height: 300,
                    modal: true,
                    show: 'fade',
                    hide: 'fade',
                    closeOnEscape: false
                }
            );
        }
        $('#errorDiv').load(CoreUI.contextRoot + '/faces/error/errorAjaxDiv.xhtml');
        $('#errorDiv').dialog('option','position','center');
        $('#errorDiv').dialog('open');
        $('#errorDiv textarea').focus();
        ae = error;
    },

    loadIndicator : function() {
        return '<img id="loadIndicator" style="height: 15px" src="img/icons/ajax-indicator-white.gif"/>';
    },
    loadIndicator2 : function() {
        return '<div id="loadIndicator" class="cssload-jumping"><span></span><span></span><span></span><span></span><span></span></div>';
    },

    loadDiv : function() {
        return '<div id="loadDiv"><center>' + CoreUI.loadIndicator() + '</center></div>';
    },

    /** 
     * if keepEnabled is false, it freezes the UI
    */
    overlayLoadIndicator: function(el, keepEnabled) {
        var top = $(el).height() / 2 - 7;
        var left = $(el).width() / 2 - 7;
        console.log('overlay top', top, 'left', left);
        $(el).prepend('<span class="load-overlay-outer" style="position: relative; float: left"><div class="load-overlay-inner" style="position: absolute; top: ' + top + 'px; left: ' + left + 'px; width: 15px; height: 15px">' + CoreUI.loadIndicator() + '</div></span>')
            .attr('disabled','disabled').addClass('disabled')
            .css('opacity', 0.7);
        if (!keepEnabled) $(el).click(function () { return false; });
    },

    removeOverlayLoadIndicator: function(el) {
        $(el).removeAttr('disabled').removeClass('disabled').css('opacity',1);
        $(el).find('.load-overlay-outer').remove();
    },

    overlayLoadIndicator2: function(el) {
        var top = $(el).height() / 2 - 100;
        var left = $(el).width() / 2 - 54;
        console.log('overlay top', top, 'left', left);
        $(el).prepend('<span class="load-overlay-outer" style="position: relative; float: left"><div class="load-overlay-inner" style="position: absolute; top: ' + top + 'px; left: ' + left + 'px;">' + CoreUI.loadIndicator2() + '</div></span>')
            .attr('disabled','disabled').addClass('disabled')
            .css('opacity', 0.7)
            .css('overflow-y', 'hidden')
            .click(function () { return false; });
        $(el).find('.load-overlay-inner').hide().delay(300).fadeIn(500);
    },

    overlayLoadIndicator3: function(el) {
        // a little less intrusive variant that can easily be restored
        var top = $(el).height() / 2 - 100;
        var left = $(el).width() / 2 - 54;
        console.log('overlay top', top, 'left', left);
        $(el).prepend('<span class="load-overlay-outer" style="position: relative; float: left"><div class="load-overlay-inner" style="position: absolute; top: ' + top + 'px; left: ' + left + 'px;">' + CoreUI.loadIndicator2() + '</div></span>')
            .css('opacity', 0.7)
            .click(function () { return false; });
        $(el).find('.load-overlay-inner').hide().delay(300).fadeIn(500);
    },

    initUnsavedChanges : function(message, selector, saveSelector) {
        if (window.nosave) return;
        if (!selector) selector = 'body';
        if (typeof window.unsavedChanges == 'undefined') window.unsavedChanges = false;
        window.unsavedChangesMessage = message;
        CoreUI.bindUnsavedChanges(selector, saveSelector);

        if (typeof Backbone != 'undefined' && Backbone.history) {
            var originalFn = Backbone.history.loadUrl;
            Backbone.history.loadUrl = function () {
                if (window.unsavedChanges) {
                    if (window.skipNextUnsavedCheck) {
                        delete window.skipNextUnsavedCheck;
                        return false;
                    } else if (confirm(window.unsavedChangesMessage)) {
                        window.unsavedChanges = false;
                        return originalFn.apply(this, arguments);
                    } else {
                        var previousFragment = Backbone.history.fragment;
                        // Resetting the location will trigger another check
                        window.skipNextUnsavedCheck = true;
                        window.location.hash = '#' + previousFragment;
                        return false;
                    }
                }
                return originalFn.apply(this, arguments);
            };
        }
    },

    bindUnsavedChanges: function(selector, saveSelector) {
        window.saveSelector = saveSelector;
        $(selector).find('input:not(.nounsave), textarea:not(.nounsave), select:not(.nounsave)').change(function() {
            console.log('unsaved changes');
            window.unsavedChanges = true;
            if (window.saveSelector) {
                $(window.saveSelector).show();
                if ($(window.saveSelector).hasClass('btn')) {
                    $(window.saveSelector).addClass('btn-primary');
                }
            }
            $('.snackbar').addClass('show');
        });
        window.onbeforeunload = function() {
            if (window.unsavedChanges) {
                if (window.saveSelector && $(window.saveSelector).length > 0) {
                    $(window.saveSelector)[0].scrollIntoView();
                    $(window.saveSelector).focus();
                }
                return window.unsavedChangesMessage;
            }
        };
    },

    iframeDialog : function(name, url, options, initoptions) {
        if (url.indexOf("?") >= 0)
            url += "&inDialog";
        else
            url += "?inDialog";
        var content = '<iframe id="iframedialog_' + name + '" src="' + url + '" width="100%" height="98%" frameborder="0">loading...</iframe>';
        if (typeof(window.top.iframeDialogs) == 'undefined' || window.top.iframeDialogs == null)
            window.top.iframeDialogs = {};
        if (typeof(window.top.iframeDialogs[name]) == 'undefined') {
            jQuery.extend(options, initoptions);
            window.top.iframeDialogs[name] = window.top.$('<div></div>').dialog(options).dialog('open');
        } else if (!window.top.iframeDialogs[name].dialog('isOpen')) {
            jQuery.extend(options, initoptions);
            window.top.iframeDialogs[name].dialog('option', options).dialog('open');
        } else {
            window.top.iframeDialogs[name].dialog('moveToTop').dialog('option', options);
        }
        window.top.iframeDialogs[name].html(content);
    },

    ajaxDialog : function(name, url, options, initoptions) {
        if (url.indexOf("?") >= 0)
            url += "&inDialog";
        else
            url += "?inDialog";
        if (typeof(window.top.ajaxDialogs) == 'undefined' || window.top.ajaxDialogs == null)
            window.top.ajaxDialogs = {};
        if (typeof(window.top.ajaxDialogs[name]) == 'undefined') {
            jQuery.extend(options, initoptions);
            window.top.ajaxDialogs[name] = window.top.$('<div></div>').dialog(options).dialog('open');
        } else if (!window.top.ajaxDialogs[name].dialog('isOpen')) {
            jQuery.extend(options, initoptions);
            window.top.ajaxDialogs[name].dialog('option', options).dialog('open');
        } else {
            window.top.ajaxDialogs[name].dialog('moveToTop').html('').dialog('option', options);
        }
        $(window.top.ajaxDialogs[name]).html(CoreUI.loadDiv());
        window.top.ajaxDialogs[name].load(url, function() {
            $('#loadDiv', window.top.ajaxDialogs[name]).remove();
        });
    },

    editGroup : function(id, title, params) {
        var paramStr = CoreUI.objToUrlParams(params);
        var url = CoreUI.contextRoot + '/faces/group/edit.xhtml?id=' + id + (paramStr ? '&' + paramStr : '');
        CoreUI.iframeView(url, title, 'group_edit',  {
            width:600,
            height: 400,
            position: [75, 50]
        });
    },

    viewUserDetails : function(id, title, params) {
        var paramStr = CoreUI.objToUrlParams(params);
        var url = CoreUI.contextRoot + '/faces/user/details.xhtml?id=' + id + (paramStr ? '&' + paramStr : '');
        CoreUI.iframeView(url, title, 'userDetails',  {
            width: 700,
            height: 500,
            position: [175, 75]
        });
    },

    viewVehicleDetails : function(id, title, params) {
        var paramStr = CoreUI.objToUrlParams(params);
        var url = CoreUI.contextRoot + '/faces/vehicle/details.xhtml?id=' + id + (paramStr ? '&' + paramStr : '');
        CoreUI.iframeView(url, title, 'vehicleDetails',  {
            width: 500,
            height: 300,
            position: [175, 75]
        });

    },

    viewJobDetails : function(id, title, page, params) {
        var paramStr = CoreUI.objToUrlParams(params);
        var url = CoreUI.contextRoot + '/faces/job/' + (page ? page : 'view') + '.xhtml?id=' + id + (paramStr ? '&' + paramStr : '');
        CoreUI.iframeView(url, title, 'job', {
            width: 1000,
            height: 500,
            position: [175, 75]
        });
    },

    newJob : function(simple, lat, lon, params) {
        var paramStr = CoreUI.objToUrlParams(params);
        var url = CoreUI.contextRoot + '/job?';
        if (lat && lon)
            url += 'lat=' + lat + '&lon=' + lon;
        url += (paramStr ? '&' + paramStr : '');
        url += '#new';
        CoreUI.iframeView(url, i18next.t('newJob'), 'job', {
            width: 1000,
            height: 500,
            position: [175, 75]
        });
    },

    viewTrack : function(id, title, params) {
        var paramStr = CoreUI.objToUrlParams(params);
        var url = CoreUI.contextRoot + '/faces/track/view.xhtml?id=' + id + (paramStr ? '&' + paramStr : '');
        CoreUI.iframeView(url, title, 'track',  {
            width: 580,
            height: 580,
            position: [75, 75]
        });
    },

    iframeView : function(url, title, dialogName, dialogOptions) {
        if (window.inDialog) {
            dialogOptions.show = 'fade';
            dialogOptions.hide = 'fade';
            window.top.CoreUI.iframeDialog(dialogName, url, {
                title: title
            }, dialogOptions);
        } else
            window.document.location = url;
    },

    objToUrlParams : function(params) {
        if (!params)
            return null;
        var str = "";
        for (var key in params) {
            str += "&" + encodeURI(key) + "=" + encodeURI(params[key]);
        }
        return str.substring(1);
    },

    keyCode : function(event) {
        return (window.event) ? event.which : event.keyCode;
    },

    setPeriodToday : function(from, to, fromTime, toTime) {
        from.val(Date.today().toString("yyyy-MM-dd")).effect('highlight');
        if (fromTime)
            fromTime.val('00:00:00').effect('highlight');
        if (to) {
            if (toTime) {
                to.val(Date.today().addDays(1).toString("yyyy-MM-dd")).effect('highlight');
                toTime.val('00:00:00').effect('highlight');
            } else
                to.val(Date.today().toString("yyyy-MM-dd")).effect('highlight');
        }
    },

    setPeriodWeek : function(from, to, fromTime, toTime) {
        var monday;
        if (Date.today().is().monday())
            monday = Date.today();
        else
            monday = Date.today().last().monday();
        from.val(monday.toString("yyyy-MM-dd")).effect('highlight');
        if (fromTime)
            fromTime.val('00:00:00').effect('highlight');
        if (to) {
            if (toTime) {
                to.val(monday.addDays(7).toString("yyyy-MM-dd")).effect('highlight');
                toTime.val('00:00:00').effect('highlight');
            } else
                to.val(monday.addDays(6).toString("yyyy-MM-dd")).effect('highlight');
        }
    },

    setPeriodMonth : function(from, to, fromTime, toTime) {
        var firstDayOfMonth = Date.today().moveToFirstDayOfMonth();
        from.val(firstDayOfMonth.toString("yyyy-MM-dd")).effect('highlight');
        if (fromTime)
            fromTime.val('00:00:00').effect('highlight');
        if (to) {
            if (toTime) {
                to.val(firstDayOfMonth.add({ months: 1 }).toString("yyyy-MM-dd")).effect('highlight');
                toTime.val('00:00:00').effect('highlight');
            } else
                to.val(firstDayOfMonth.add({ months: 1 }).add({ days: -1 }).toString("yyyy-MM-dd")).effect('highlight');
        }
    },

    checkTime : function(input) {
        var val = $(input).val();
        if (val.length == 0)
            return;
        if (val.indexOf(':') < 0 && val.length > 2) {
            val = val.substring(0,4);
            // add colon
            if (val.length == 3)
                val = '0' + val;
            val = val.substring(0,val.length-2) + ':' + val.substring(val.length-2);
        } else if (val.length <= 2) {
            // pad zeroes if only hours written
            val = val + ':00';
        } else if (val.length > 5) {
            val = val.replace(':','');
            val = val.substring(0,2) + ':' + val.substring(2,4);
        }
        while (val.indexOf(':') >= 0 && val.indexOf(':') < 2)
            // pad zero in front
            val = '0' + val;
        $(input).val(val);
    },

    formLoad : function() {
        $('input[type=submit]').button();
        $('.button').button();
        $('.smallButton').button().css('font-size','11px');
        $('.tipsy').hide();
        $('[title]').tipsy();
        if (document.activeElement && document.activeElement.tagName == 'BODY')
            $('.focus').focus();
    },

    home: function() {
        location.hash = '';
    },

    backReload : function() {
        window.location.href = document.referrer;
    },

    textAreaChangeOnPaste: function(textarea) {
        if (!textarea.tagName) textarea = textarea[0];
        textarea.onpaste = function(e) {
            var pastedText = undefined;
            if (window.clipboardData && window.clipboardData.getData) { // IE
                pastedText = window.clipboardData.getData('Text');
            } else if (e.clipboardData && e.clipboardData.getData) {
                pastedText = e.clipboardData.getData('text/plain');
            }
            $(textarea).val(pastedText);
            $(textarea).change();
            return false; // Prevent the default handler from running.
        };
    },

    textAreaAllowTab : function(textarea) {
        if (!textarea.tagName) textarea = textarea[0];
        // Allow tab key in textarea (but not in IE because... well you know..)
        if (!(window.attachEvent && !window.addEventListener)) { // == IE <= 8
            $(textarea).keydown(function(e) {
                if(e.keyCode === 9) {
                    var start = textarea.selectionStart;
                    var end = textarea.selectionEnd;
                    var value = $(textarea).val();
                    $(textarea).val(value.substring(0, start) + "\t" + value.substring(end));
                    textarea.selectionStart = textarea.selectionEnd = start + 1;
                    e.preventDefault();
                    return false;
                }
            });

        }

    },

    isTouchDevice: function() {
        return !!('ontouchstart' in window);
    },

    downloadXmlAsFile: function(xml, filename, escapeEncoding){
        this.downloadTextAsFile(new XMLSerializer().serializeToString(xml), filename, 'application/xml', escapeEncoding);
    },

    downloadPaxmlAsFile: function(xml, filename){
        var paxml = new XMLSerializer().serializeToString(xml);
        // When XMLSerializer serializes the xml to String, it loses some important prefixes in the attributes, ex. xmlns:xsi becomes xsi.
        // Because of this we modify the string to insert the prefixes again.
        if (paxml.indexOf('xmlns') == -1)
            paxml = paxml.replace(" xsi="," xmlns:xsi=").replace(" noNamespaceSchemaLocation="," xsi:noNamespaceSchemaLocation=")
        this.downloadTextAsFile(paxml, filename, 'application/xml');
    },

    downloadTextAsFile: function(text, filename, mimeType, escapeEncoding) {
        if (!mimeType) mimeType = 'text/plain;charset=utf-8';
        if (!filename) filename = 'download.txt';
        var pom = document.createElement('a');
        pom.setAttribute('href', 'data:' + mimeType + ',' + (escapeEncoding ? escape(text) : encodeURIComponent(text)))// escape because Visma is that old!?
        pom.setAttribute('download', filename);
        document.body.appendChild(pom);
        pom.click();
        document.body.removeChild(pom);
    },

    downloadTsvAsExcel: function(tsv, filename) {
        var form = document.createElement('form');
        form.acceptCharset = 'utf-8';
        form.setAttribute('method','post');
        form.setAttribute('action', Core.contextRoot.replace("/core", "") + '/vault/spreadsheet/xlsx/' + encodeURIComponent(filename));
        var text = document.createElement('textarea');
        text.name = 'tsv';
        text.textContent = tsv;
        form.appendChild(text);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    },

    downloadXML: function(document, filename) {
        var form = document.createElement('form');
        form.acceptCharset = 'utf-8';
        form.setAttribute('method', 'post');
        form.setAttribute('action', Core.contextRoot.replace("/core", "") + "/vault/xml/" + encodeURIComponent(filename));
        var text = document.createElement('textarea');
        text.name = "xml";
        text.textContent = new XMLSerializer().serializeToString(document);
        form.appendChild(text);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    },

    dropdownKeys: function(selector) {
        $(selector).keydown(function(e){
            var self = this;
            if(e.which == 13 || e.which == 40) {
                setTimeout(function() {
                    $(self).parent().find('li a').first().focus();
                }, 100);
            } else {
                console.log(e);
            }
        });
        $(selector).parent().find('li a').keydown(function(e){
            if(e.which == 40) { // down
                $(this).parent().next().find('a').focus();
                return false; // stops the page from scrolling
            }
            if(e.which == 38) { // up
                $(this).parent().prev().find('a').focus();
                return false; // stops the page from scrolling
            }
        });
    },

    setupWideScreen: function() {
        if ($('body').width() > CoreUI.wideScreenWidth) {
            $('#content').width('98%');
            if ($('body').width() > CoreUI.maxWideScreenWidth) $('#content').css('max-width', CoreUI.maxWideScreenWidth);
        }
    },

    clickGoHref: function(url, event) {
        if (!event) console.error('Missing event argument for CoreUI.clickGoHref');
        if (url.indexOf('#') == 0) return CoreUI.clickGoHash(url.substring(1), event);
        if (event && (event.ctrlKey || event.metaKey))
            window.open(url, '_blank')
        else
            location.href = url;
    },

    clickGoHash: function(hash, event) {
        if (!event) console.error('Missing event argument for CoreUI.clickGoHash');
        if (event && (event.ctrlKey || event.metaKey))
            window.open('#' + hash, '_blank')
        else
            location.hash = hash;
    },

    randomTimeout: function(callback, mintime, maxtime, context, timeout) {
        if (typeof timeout === 'number') clearTimeout(timeout);
        return setTimeout(function() {
            callback.apply(context);
            if (timeout) delete timeout;
        }, mintime + Math.random()*(maxtime-mintime));
    },

};
